module.exports = __webpack_public_path__ + "img/icon-mis-libros.cfe951da.svg";